// extracted by mini-css-extract-plugin
export default {"header":"GuidelinesModal_header__BqRMu","brand":"GuidelinesModal_brand__1fA7n","li":"GuidelinesModal_li__fZBZE","bold":"GuidelinesModal_bold__RjJ5n"};